module.exports = __webpack_public_path__ + "img/barometer.8400bd01.svg";